var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: {
      height: '100%',
      overflow: 'hidden',
      width: '100%'
    }
  }, [_c('div', {
    class: {
      'intro-container': true,
      'is-mobile-browser': _vm.isMobile && !_vm.isIOSApp
    },
    style: {
      'background-image': _vm.backgroundImage
    }
  }, [!_vm.isPlayingAnimation ? _c('h1', {
    staticClass: "activity-title",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n      Assessment Accelerator\n    ")]) : _vm._e(), !_vm.isPlayingAnimation ? _c('portal', {
    attrs: {
      "to": "next-activity-button"
    }
  }, [_c('next-activity-button', {
    attrs: {
      "on-click": _vm.handleOnClick
    }
  })], 1) : _vm._e(), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPlayingAnimation,
      expression: "isPlayingAnimation"
    }],
    ref: "assessmentAcceleratorAnimationVideo",
    attrs: {
      "id": "animation-video",
      "playsinline": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoSrc
    }
  })])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }